export default "__VITE_ASSET__341818a0__"